import de from './de/index.js';
import en from './en/index.js';

export default {
  de,
  en
};